__turbopack_context__.v({
  "container": "ywxoXG_container",
  "content": "ywxoXG_content",
  "footer": "ywxoXG_footer",
  "noteHeader": "ywxoXG_noteHeader",
  "orderReceivedNote": "ywxoXG_orderReceivedNote",
});
